import { AutomationType } from "../../config/enums";

export const automationTypeOptions = [
  {
    label: "Scheduled",
    value: AutomationType.Scheduled,
    description:
      "Run a communication daily or relative to fixtures for a selected competition and team.",
  },
  {
    label: "Triggered",
    value: AutomationType.Triggered,
    description:
      "Run a communication when a supported business event is triggered.",
  },
];

export const automationScheduleModeOptions = [
  {
    label: "Daily",
    value: "Daily",
    description: "Send a communication at the same time every day.",
  },
  {
    label: "Fixture",
    value: "Fixture",
    description:
      "Send relative to fixtures for a selected competition and team.",
  },
];
